/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LeadTimeModalComponent} from './lead-time-modal.component';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {ActiveInputModule} from '../active-input/active-input.module';
import {InputModule} from '../../../../shared/input/input.module';

@NgModule({
    declarations: [LeadTimeModalComponent],
    imports: [
        CommonModule,
        GenericModalModule,
        ActiveInputModule,
        InputModule
    ]
})
export class LeadTimeModalModule {
}
